<template>
  <div class="maintenance-tab">
      <ApiManager />
  </div>
</template>

<script setup>
import ApiManager from "./ApiManager.vue";
</script>

<style scoped>
.maintenance-tab {
  position: relative;
  padding: 8px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .maintenance-tab {
    padding: 0.5em 0.2em;
    width: 100% !important;
    max-width: 100% !important;
  }
}
.script-toggle-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}
/* Maintenance tab specific styles can be added here */
</style>
